import * as CL from '@design-system/component-library';
import { dsClass } from '../../../../../../common/constants/dsClasses';
import { t } from '../../../../../../common/i18n';

interface CreateNewUserButtonProps {
  onClick: () => void;
  isLoading?: boolean;
}

export const CreateNewUserButton = ({ onClick, isLoading = false }: CreateNewUserButtonProps) => {
  return (
    <CL.Button
      color="primary"
      onClick={onClick}
      className={dsClass.MARGIN_TOP_4}
      size="m"
      loading={isLoading}
      disabled={isLoading}
    >
      {t.A2WC('create a new user')}
    </CL.Button>
  );
};
